import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const ConnectorMiddleIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 36">
            <path d="M7.5 0V7.77419M7.5 7.77419C7.5 12.5161 9.3 18 16.5 18M7.5 7.77419V36" fill="none" stroke="var(--iconFill)" />
        </SvgIcon>
    );
};
import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const ConnectorMiddleIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 36">
            <path d="M7.5 0V7.77419M7.5 7.77419C7.5 12.5161 9.3 18 16.5 18M7.5 7.77419V36" fill="none" stroke="var(--iconFill)" />
        </SvgIcon>
    );
};
